import { DEFAULT_COLOR, mapColorToPalette } from '@entities/category';
import { CategoryData } from '@shared/hooks/useFetchQrCode';
import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';

interface CategoryListProps {
  categories: CategoryData[];
}

export const CategoryList = ({ categories }: CategoryListProps) => {
  return (
    <ul {...stylex.props(styles.categoriesWrapper)}>
      {categories.map(({ title, color }, i) => (
        <li
          key={i}
          {...stylex.props(
            styles.categoryItem,
            !!color && color !== DEFAULT_COLOR && styles.categoryItemColored(mapColorToPalette[color])
          )}
        >
          {title}
        </li>
      ))}
    </ul>
  );
};
